export default {
  application_setting: 'Application Setting',
  application_information: 'Application Information',
  public_key: 'Public Key',
  shared_application_setting: 'Shared Application Setting',
  secret_key: 'Secret Key',
  ip_white_list: 'IP White List',
  ip_address: 'IP Address',
  user_authentication: 'User Authentication'
}
